import React from "react";
import ReactSelect from "@ui/ReactSelect";
import { useDegradationTypeInput } from "./useDegradationTypeInput";

interface P {
  focusableRef: React.RefObject<{
    focus: () => void;
  }>;
  name: string;
  placeholder: string;
  entry: { degradationTypeId: string | null };
  column: string;
  allowDegradationTypeCreation?: boolean;
  setDirty: (dirty: boolean, column: string) => void;
}

const DegradationTypeSelect = ({
  name,
  placeholder,
  setDirty,
  entry,
  allowDegradationTypeCreation = false,
  ...props
}: P) => {
  const degradationType = useDegradationTypeInput(entry);

  React.useEffect(() => {
    setDirty(degradationType.dirty, props.column);
  }, [degradationType.dirty, props.column, setDirty]);

  return (
    <ReactSelect
      {...props}
      menuPortalTarget={window.document.body}
      ref={props.focusableRef as React.RefObject<HTMLDivElement>}
      name={name}
      placeholder={placeholder}
      value={degradationType.selectedDegradationType}
      options={degradationType.degradationTypeOptions}
      onChange={degradationType.handleDegradationTypeChanged}
      onCreate={
        allowDegradationTypeCreation ? degradationType.handleDegradationTypeCreated : undefined
      }
      onEdit={
        allowDegradationTypeCreation ? degradationType.handleDegradationTypeEdited : undefined
      }
      onDelete={
        allowDegradationTypeCreation ? degradationType.handleDegradationTypeDeleted : undefined
      }
    />
  );
};

export default React.memo(DegradationTypeSelect);
